import { AmbusherEffect } from 'game/extended/heros/ranger/ambusher/ambusher_effect'

export default {
    events: {},
    effects: {
        AmbusherEffect
    },
    requirements: {}
}